// extracted by mini-css-extract-plugin
export default {"switchWrapper":"switch_switchWrapper__t68bO","sun":"switch_sun__rZlgT","moon":"switch_moon__h7sSh"};